import React from 'react';
import { TextField } from '@vitalsource/vstui'
import { Search as SearchIcon} from '@vitalsource/vstui-icons';
import '../../styles/ProjectList.css';
import '../../styles/Layouts.css';
import ProjectFolder from "./ProjectFolder";
import styled from "styled-components";
import {ProjectDataItem} from "../types/StudioAPITypes";
import {sortByNames} from "../utils/sortCompUtils";

const SearchField = styled(TextField)`
  float:left;
  margin:auto;
  height: 40px;
  width: 522px;
  > input {
    min-height: 0;
    height: 100%;
    width: 100%
  }
`;

const SearchIconOverLay = styled(SearchIcon) `
  position: relative;
  left: -44px;
  display: inline-block;
  margin: 12px 16px 12px 12px;
  height: 16px;
  width: 16px;

`;

export interface ProjectsListProps {
  projects: ProjectDataItem[];
  filter: string;
  updateProjectsFilter: (e: any) => void;
}

const ProjectsList = (props: ProjectsListProps) => {
  const { projects, filter, updateProjectsFilter } = props;

  const mapProjectsToProjectFolder = (fitleredProjects: any[], filter: string) => {
    let projectContainerList = fitleredProjects.map((project) => {
      return (
        <div key={project.id}>
          <ProjectFolder
            id={project.id}
            name={project.name}
            productCount={project.productCount}
          />
        </div>
      )
    });

    if(projectContainerList.length) {
      return projectContainerList;
    } else {
      return Array.apply(null, Array(8)).map( (i: any, j: number) => {
        return (
          <div key={j}>
            <ProjectFolder
              id=""
              name=""
              productCount={0}
            />
          </div>
        )
      });
    }

  };

  const applyFilterToProjects = (projects: ProjectDataItem[], filter: string) => {
    return sortTitles(projects.filter((project) => {
      return project.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1
    }));
  };

  const sortTitles = (projects: ProjectDataItem[]) => {
    return sortByNames<ProjectDataItem>(projects);
  };

  const filteredProjects = applyFilterToProjects(projects, filter);

  return (
    <div className="page-container">
      <div className={"page-inner-container projects-page"}>
        <div className="project-list-search-field">
            <SearchField
              className={"project-list-search-field-vst"}
              placeholder="Search by name..."
              maxLength={200}
              onChange={updateProjectsFilter}
              type="search"
              size="large"
              label={"Search by name"}
              labelHidden
            />
          {!props.filter.length  ? <SearchIconOverLay/>: ""}
        </div>
        <div>
          <div className="empty-product-msg">{!filteredProjects.length && filter !== "" ? "No results found" : ""}</div>
          <div className={"card-grid library-grid" + ((!filteredProjects.length && props.filter.length) ? ' project-list-empty': '')}>
          {mapProjectsToProjectFolder(filteredProjects, filter)}
        </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsList;
